// @ts-nocheck
import {
  alpha,
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { titleSx } from "../../user-clients/components/AddClientModal";
import { useEffect, useMemo, useState } from "react";
import * as Yup from "yup";
import {
  CLIENT_EMAIL,
  CLIENT_EMAIL_LABEL,
} from "../../../utils/constants/client";
import { useFormik } from "formik";
import { phoneNumberForApi } from "../../../utils/methods/formatters";
import { addBillingInfoToEventAction } from "../../../store/actions/client";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { phoneNumberFormat } from "../../../appCalcutions";
import { CustomTooltip } from "../../../components/Tooltip/ClientTool";
import {
  CustomChip,
  SmallAddButton,
} from "../../../components/Custom/CustomIconButton";
import { AddInvoiceEamils } from "../../user-clients/components/AddInvoiceEmails";
import { alertDialogAciton } from "../../../store/actions/auth";

export default function EventBillingTab({
  eventInfo,
  handleClose,
  updateEvent,
}) {
  const addInvoiceInit = useMemo(() => {
    return {
      status: false,
      type: CLIENT_EMAIL.estimate,
    };
  }, []);
  const initialValues = {
    emails: {
      estimateEmails: [],
      invoiceEmails: [],
      depositInvoiceEmails: [],
    },
  };

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const [addInvoice, setAddInvoice] = useState(addInvoiceInit);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const emailSchema = (type) => {
    const emailName = `${type}Email`;
    const mobileName = `${type}Mobile`;
    return Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .trim()
          .max(200, "Name should have at most 200 characters"),
        [emailName]: Yup.string()
          .trim()
          .email("Invalid email")
          .required("Email required"),
        [mobileName]: Yup.string()
          .matches(/^\d{3}-\d{3}-\d{4}$/, { message: "Phone number must be of 10 digit", excludeEmptyString: true }),
      }),
    );
  };

  const validationSchema = Yup.object().shape({
    emails: Yup.object()
      .shape({
        estimateEmails: emailSchema(CLIENT_EMAIL.estimate),
        invoiceEmails: emailSchema(CLIENT_EMAIL.invoice),
        depositInvoiceEmails: emailSchema(CLIENT_EMAIL.depositInvoice),
      })
      .optional(),
  });

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values) => {
      setLoading(true);
      const payload = {
        ...(eventInfo?.submittedBillingInfo || {}),
        ...values,
        emails: {
          depositInvoiceEmails: values?.emails?.depositInvoiceEmails?.map(
            (e) => ({
              ...e,
              depositInvoiceMobile: phoneNumberForApi(e?.depositInvoiceMobile),
            }),
          ),
          invoiceEmails: values?.emails?.invoiceEmails?.map((e) => ({
            ...e,
            invoiceMobile: phoneNumberForApi(e?.invoiceMobile),
          })),
          estimateEmails: values?.emails?.estimateEmails?.map((e) => ({
            ...e,
            estimateMobile: phoneNumberForApi(e?.estimateMobile),
          })),
        },
      };

      // api to update billing information data

      dispatch(
        addBillingInfoToEventAction({
          payload: {
            data: {
              billingData: payload,
            },
            params: {
              eventId: eventInfo?._id,
            },
          },
          successCallback: (msg) => {
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Success",
                message: msg || "Billing Details updated",
              }),
            );
            setLoading(false);
            handleClose();
            updateEvent();
          },
          failureCallback: (msg) => {
            setLoading(false);
            dispatch(
              alertDialogAciton({
                open: true,
                title: "Error",
                message: msg || "Failed to update billing details",
              }),
            );
          },
        }),
      );
    },
  });

  const {
    values,
    setValues,
    touched,
    handleBlur,
    handleChange,
    errors,
    handleSubmit,
    setFieldValue,
  } = formik;

  useEffect(() => {
    if (eventInfo?.submittedBillingInfo) {
      formik.setValues({
        emails: {
          estimateEmails:
            eventInfo?.submittedBillingInfo?.emails?.estimateEmails?.map(
              (e) => ({
                ...e,
                estimateMobile: phoneNumberFormat(e?.estimateMobile),
              }),
            ) || [],
          invoiceEmails:
            eventInfo?.submittedBillingInfo?.emails?.invoiceEmails?.map(
              (e) => ({
                ...e,
                invoiceMobile: phoneNumberFormat(e?.invoiceMobile),
              }),
            ) || [],
          depositInvoiceEmails:
            eventInfo?.submittedBillingInfo?.emails?.depositInvoiceEmails?.map(
              (e) => ({
                ...e,
                depositInvoiceMobile: phoneNumberFormat(
                  e?.depositInvoiceMobile,
                ),
              }),
            ) || [],
        },
      });
    } else {
      formik.setValues(initialValues);
    }
  }, [eventInfo]);

  function addInvoiceAppendFunc({ values, type }) {
    if (type == "all") {
      const estimateEmails = `${CLIENT_EMAIL.estimate}Emails`;
      const depositInvoiceEmails = `${CLIENT_EMAIL.depositInvoice}Emails`;
      const invoiceEmails = `${CLIENT_EMAIL.invoice}Emails`;
      setValues((prev) => ({
        ...prev,
        emails: {
          ...prev?.emails,
          estimateEmails: [
            ...(prev?.emails?.[estimateEmails] || []),
            {
              estimateEmail: values?.allEmail,
              estimateMobile: values?.allMobile,
              name: values?.name,
            },
          ],
          [depositInvoiceEmails]: [
            ...(prev?.emails?.[depositInvoiceEmails] || []),
            {
              depositInvoiceEmail: values?.allEmail,
              depositInvoiceMobile: values?.allMobile,
              name: values?.name,
            },
          ],
          [invoiceEmails]: [
            ...(prev?.emails?.[invoiceEmails] || []),
            {
              invoiceEmail: values?.allEmail,
              invoiceMobile: values?.allMobile,
              name: values?.name,
            },
          ],
        },
      }));
      return;
    }
    const key = `${type}Emails`;
    setValues((prev) => ({
      ...prev,
      emails: {
        ...prev?.emails,
        [key]: [...(prev?.emails?.[key] || []), values],
      },
    }));
  }

  const isBillingReadOnly = false;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        flexDirection: "column",
        marginTop: 2,
        gap: "1rem",
      }}
    >
      <Box
        sx={{
          border: `1px solid ${getCssVariableHandler({
            variableName: "--primary-pink-hex",
          })}`,
          borderRadius: "0.5rem",
          maxWidth: "50rem",
          p: 2,
          mb: 2,
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Typography sx={{ ...titleSx, display: "inline" }}>
              Billing Informations:
            </Typography>

            {!isBillingReadOnly && (
              <SmallAddButton
                onClick={() => {
                  setAddInvoice({ status: true, type: "all" });
                }}
                title={"Add to all"}
              />
            )}
          </Grid>

          <div style={{ paddingLeft: "1rem", paddingTop: "1rem" }}>
            {addInvoice?.status && addInvoice?.type == "all" ? (
              <AddInvoiceEamils
                open={addInvoice?.status}
                handleClose={() => setAddInvoice(addInvoiceInit)}
                type={"all"}
                addEmail={addInvoiceAppendFunc}
              />
            ) : null}
          </div>
          {[
            CLIENT_EMAIL.estimate,
            CLIENT_EMAIL.depositInvoice,
            CLIENT_EMAIL.invoice,
          ]?.map((item) => {
            const key = `${item}Emails`;
            return (
              <Grid item xs={12} key={item}>
                <Typography
                  sx={{
                    ...titleSx,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: getCssVariableHandler({
                      variableName: "--white-rgb",
                    }),
                    paddingBottom: 1,
                  }}
                >
                  {CLIENT_EMAIL_LABEL?.[item]} Profiles:
                  {!isBillingReadOnly && (
                    <SmallAddButton
                      onClick={() => {
                        setAddInvoice({ status: true, type: item });
                      }}
                    />
                  )}
                </Typography>
                {addInvoice?.status && addInvoice?.type == item ? (
                  <AddInvoiceEamils
                    open={addInvoice?.status}
                    handleClose={() => setAddInvoice(addInvoiceInit)}
                    type={addInvoice?.type}
                    addEmail={addInvoiceAppendFunc}
                  />
                ) : null}
                {values?.emails?.[key]?.length == 0 ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography
                      sx={{
                        border: `1px solid ${getCssVariableHandler({
                          variableName: "--primary-pink-hex",
                        })}`,
                        borderRadius: "0.5rem",
                        px: 2,
                        py: "2px",
                        mb: 1,
                        mx: "auto",
                        backgroundColor: alpha("#fff", 0.2),
                      }}
                      component={"span"}
                      textAlign={"center"}
                    >
                      No {key} Profile Added
                    </Typography>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      gap: "0.5rem",
                      flexWrap: "wrap",
                    }}
                  >
                    {values?.emails?.[key]?.map((e, i) => {
                      return (
                        <CustomChip
                          key={i}
                          label={
                            <CustomTooltip
                              title={
                                <Box
                                  key={i}
                                  sx={{
                                    border: `1px solid ${getCssVariableHandler({
                                      variableName: "--primary-pink-hex",
                                    })}`,
                                    borderRadius: "0.5rem",
                                    p: 1,
                                    mb: 1,
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                      gap: isSmallScreen ? "0" : "1rem",
                                      width: "100%",
                                      flexWrap: "wrap",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-start",
                                        gap: isSmallScreen
                                          ? "0.25rem"
                                          : "0.5rem",
                                        width: "100%",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: getCssVariableHandler({
                                            variableName: "--primary-pink-hex",
                                          }),
                                          fontWeight: "500",
                                        }}
                                      >
                                        Name:{" "}
                                      </Typography>
                                      <Typography>{e?.name || e?.[`${item}Email`]}</Typography>
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                      gap: isSmallScreen ? "0" : "1rem",
                                      width: "100%",
                                      flexWrap: "wrap",
                                      flexDirection: isSmallScreen
                                        ? "column"
                                        : "row",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-start",
                                        gap: isSmallScreen
                                          ? "0.25rem"
                                          : "0.5rem",
                                        width: "100%",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: getCssVariableHandler({
                                            variableName: "--primary-pink-hex",
                                          }),
                                          fontWeight: "500",
                                        }}
                                      >
                                        Phone:{" "}
                                      </Typography>
                                      <Typography>
                                        {phoneNumberFormat(
                                          e?.[`${item}Mobile`],
                                        )}
                                      </Typography>
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "flex-start",
                                      gap: isSmallScreen ? "0" : "1rem",
                                      width: "100%",
                                      flexWrap: "wrap",
                                      flexDirection: isSmallScreen
                                        ? "column"
                                        : "row",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-start",
                                        alignItems: "flex-start",
                                        gap: isSmallScreen
                                          ? "0.25rem"
                                          : "0.5rem",
                                        width: isSmallScreen ? "100%" : "47%",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          color: getCssVariableHandler({
                                            variableName: "--primary-pink-hex",
                                          }),
                                          fontWeight: "500",
                                        }}
                                      >
                                        Email:{" "}
                                      </Typography>
                                      <Typography>
                                        {e?.[`${item}Email`]}{" "}
                                      </Typography>
                                    </Typography>
                                  </Box>
                                </Box>
                              }
                            >
                              {e?.name || e?.[`${item}Email`]}
                            </CustomTooltip>
                          }
                          onDelete={() => {
                            setValues((prev) => ({
                              ...prev,
                              emails: {
                                ...prev?.emails,
                                [`${item}Emails`]: [`${item}Emails`]?.filter(
                                  (email) =>
                                    email?.[`${item}Email`] !==
                                    e?.[`${item}Email`],
                                ),
                              },
                            }));
                          }}
                        />
                      );
                    })}
                  </Box>
                )}
              </Grid>
            );
          })}
        </Grid>
      </Box>

      <Box
        className="bottom-btn-box"
        sx={{
          display: "flex",
          flexDirection: isSmallScreen ? "column" : "row",
          width: isSmallScreen ? "100%" : "auto",
        }}
      >
        <Button
          className="btn-black"
          sx={{
            width: isSmallScreen ? "100%" : "auto",
          }}
          onClick={() => {
            handleClose();
          }}
        >
          <Typography className="btn-text">CLOSE</Typography>
        </Button>
        <Button
          sx={{
            width: isSmallScreen ? "100%" : "auto",
            cursor: "pointer",
          }}
          className="btn-pink"
          onClick={() => {
            handleSubmit();
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : (
            <Typography className="btn-text">Update</Typography>
          )}
        </Button>
      </Box>
    </Box>
  );
}

EventBillingTab.propTypes = {
  eventInfo: PropTypes.object,
  handleClose: PropTypes.func,
  updateEvent: PropTypes.func,
};